/**
 * Created by mateimisarca on 2019-06-07
 */

import ContactPage from './contact-page';

export default ContactPage;
